import { getAuth } from "firebase/auth";
import Environment from "../../utils/Environement";
import { formatRestaurantCardToCatalog } from "../../utils/formater";

import HubRiseApi from "../api/HubRiseApi";
import { StoreActionType } from "../constant/ActionConstant";
import AppDispatcher from "../dispatcher/AppDispatcher";
import PopinaRestaurant from "../model/popina/PopinaRestaurant";
import Service from "../model/service/Service";

class HubRiseActionCreator {
  private api: HubRiseApi;

  constructor() {
    this.api = new HubRiseApi(Environment.isDev, Environment.isPopina);
  }

  async loadHubRiseServiceUser() {
    const auth = getAuth()
    const useruid = auth.currentUser?.uid
    if (useruid === undefined) {
      throw new Error("error firebase not connected");
    }
    try {
      const res = await this.api.loadService(useruid);
      const service = res?.data;

      const serviceUser = service
        ? new Service(service)
        : new Service();

      AppDispatcher.dispatch({
        type: StoreActionType.SET_HUBRISE_SERVICE,
        data: serviceUser
      });
    } catch (e) {
      throw e;
    }
  }

  navigateToAuthorizationPage = (redirectUri: string, accountName: string, locationName: string, countryCode: string) => {
    this.api.navigateToAuthPage(redirectUri, accountName, locationName, countryCode);
  };

  async connectHubRiseServiceUser(authorizationCode: string) {
    const auth = getAuth()
    const useruid = auth.currentUser?.uid
    if (useruid === undefined) {
      throw new Error("error firebase not connected");
    }
    try {
      const res = await this.api.connectService(authorizationCode, useruid);
      const data = res?.data?.service;
      const service = new Service(data);

      AppDispatcher.dispatch({
        type: StoreActionType.SET_HUBRISE_SERVICE,
        data: service
      });
    } catch (e) {
      throw e;
    }
  }

  async disconnectHubRiseService() {
    const auth = getAuth()
    const useruid = auth.currentUser?.uid
    if (useruid === undefined) {
      throw new Error("error firebase not connected");
    }
    try {
      await this.api.disconnectService(useruid);
      AppDispatcher.dispatch({
        type: StoreActionType.SET_HUBRISE_SERVICE,
        data: new Service()
      });
    } catch (e) {
      throw e;
    }
  }

  async upLoadCatalog(service: Service, restaurantCard: PopinaRestaurant) {
    const auth = getAuth()
    const useruid = auth.currentUser?.uid
    const catalog = formatRestaurantCardToCatalog(restaurantCard);
    console.log("HUBRISE CATALOG:",{catalog})
    return this.api.upLoadCatalog(
      service.catalogId!,
      catalog,
      useruid!
    );
  }
}

const hubriseActionCreator = new HubRiseActionCreator();
export default hubriseActionCreator;
